import { Component } from '@angular/core'

@Component({
  selector: 'skeleton-preloader-tile-component',
  templateUrl: './skeleton.preloader.tile.component.html',
  styleUrls: ['./skeleton.preloader.tile.component.scss']
})
export class SkeletonPreloaderTileComponent {}
